<template>
  <vxe-grid
    border
    auto-resize
    size="mini"
    :data="data"
    :columns="columns"
    :empty-text="$l('table_label_readBox_skuEmpty') || '暂无SKU箱号'"
  >
    <template #listBoxNo="{row}">
      <div class="box-no-list">
        <el-tag
          v-for="boxNo in row.listBoxNo"
          :key="`${row.listBoxNo}-${boxNo}`"
          size="mini"
          class="mr-1 mb-1"
        >
          {{ boxNo }}
        </el-tag>
        <span v-if="!row.listBoxNo.length">-</span>
      </div>
    </template>

    <template #optHeader>
      <div class="d-flex justify-content-center">
        <el-button
          size="mini"
          type="text"
          :disabled="!data.length"
          @click="setBox(data)"
        >
          {{ $l('btn_readBox_setAllBoxNo') || '一键设置' }}
        </el-button>
      </div>
    </template>

    <template #opt="{row}">
      <div class="d-flex justify-content-center">
        <el-tooltip
          effect="dark"
          :content="$l('btn_readBox_setBoxNo') || '设置箱号'"
          placement="top"
        >
          <i class="el-icon-check tool-btn" @click="setBox([row])" />
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import lodash from 'lodash'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    amzFtyNoticeOutCode: { type: String, default: '' },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      columns: [
        {
          field: 'sku',
          title: this.$l('table_label_sku') || 'SKU',
          minWidth: 180,
        },
        {
          field: 'listBoxNo',
          title: this.$l('table_label_boxNo') || '箱号',
          minWidth: 420,
          slots: { default: 'listBoxNo' },
        },
        {
          field: 'opt',
          width: 100,
          align: 'center',
          headerAlign: 'center',
          slots: { header: 'optHeader', default: 'opt' },
        },
      ],
    }
  },
  methods: {
    async setBox(items) {
      if (!items?.length) {
        this.$message.warning(
          this.$l('table_label_readBox_skuEmpty') || '暂无SKU箱号'
        )
        return
      }

      const confirm = await this.$confirm(
        this.$l('tips_readBox_setBoxNoConfirm') || '是否确认设置箱号？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const skus = Object.fromEntries(
        lodash.map(items, ({ sku, listBoxNo }) => [sku, listBoxNo])
      )

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFtyNoticeOutDetailSetBoxNoApi({
          amzFtyNoticeOutCode: this.amzFtyNoticeOutCode,
          skus,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      const error = status !== 200

      this.$message({
        showClose: true,
        message: msg || this.$l('tips_readBox_setBoxNoFail') || '设置失败！',
        type: error ? 'error' : 'success',
      })

      if (error) return

      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped></style>
